<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>how_to_reg</md-icon>
            </div>
            <add-button @add-click="addConsultant"></add-button>
          </md-card-header>
          <md-card-content>
            <md-table
              v-model="consultants"
              class="table-striped"
              table-header-color="primary"
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Name">{{ item.name }}</md-table-cell>
                <md-table-cell md-label="Email">{{ item.email }}</md-table-cell>
                <md-table-cell class="text-right">
                  <edit-button
                    :isSmall="true"
                    @edit-click="editConsultant(item.id)"
                  ></edit-button>
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state
                md-label="No Consultants Found"
              ></md-table-empty-state>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      consultants: "data-management-client/consultants"
    })
  },
  async created() {
    await this.$store.dispatch("data-management-client/getConsultantListing");
  },
  methods: {
    editConsultant(id) {
      this.$router.push({
        name: "Edit Consultant",
        params: { consultantId: id }
      });
    },
    addConsultant() {
      this.$router.push({ name: "Add Consultant" });
    }
  }
};
</script>

<style>
.text-right .md-table-cell-container {
  display: flex;
  justify-content: flex-end;
}
</style>
